"use client";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import Close from "@/app/assets/icons/close";
import { ICM_ZOOM, subDomains } from "@/app/utils/constants";
import useMobile from "@/app/hooks/use-mobile";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import { getReleventDomain } from "@/app/utils/helper";

export default function Consultation() {
    const pathName = usePathname();
    const { isMobile } = useMobile();
    const [isDismissed, setIsDismissed] = useState(false);
    const [isAllowedPage, setAllowedPage] = useState(false);

    useEffect(() => {
        if (typeof window !== "undefined") {
            setAllowedPage(
                window.location.pathname === "/" ||
                    window.location.pathname === "/unlisted-shares" ||
                    (pathName === "/platform" && getReleventDomain().includes(subDomains.NEUTRAL)),
            );
        }

        return () => setAllowedPage(false);
    }, []);

    return !isDismissed && isAllowedPage ? (
        <div className="fixed bottom-0 left-0 z-50 w-full bg-banner-gradient px-s9 py-s7 text-white md:py-s6 animate-slide-up">
            <div className="md:px-auto mx-auto flex max-w-[100%] items-center justify-between md:container md:px-6">
                <div className="flex items-center justify-between text-xs md:text-base">
                    <span
                        className="flex items-center gap-3 transition-all duration-300 hover:gap-6 cursor-pointer"
                        onClick={() => {
                            if (typeof window !== "undefined") {
                                window.location.href = ICM_ZOOM;
                            }
                        }}
                    >
                        Book a free consultation with our experts{" "}
                        <RegularButton
                            noIcon
                            showRightIcon={false}
                            size={ButtonSize.Small}
                            variant={ButtonVariant.SecondaryDefault}
                            className="bg-white md:block"
                            label="Book now"
                        />
                    </span>
                </div>
                <span onClick={() => setIsDismissed(true)} className="cursor-pointer">
                    <Close size={isMobile ? 14 : 24} />
                </span>
            </div>
        </div>
    ) : null;
}
